"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Tries to override param in storage
 * @returns {boolean}
 */
var overrideKeyValuePairInStore = function (storage, key, value) {
    if (storage.getItem(key)) {
        storage.setItem(key, value);
        return true;
    }
    return false;
};
/**
 * Overrides params in sessionStorage and localStorage
 * If no override is done, param is written to sessionStorage
 */
var overrideKeyValuePair = function (key, value) {
    var overwritten = false;
    if (overrideKeyValuePairInStore(localStorage, key, value)) {
        overwritten = true;
    }
    if (overrideKeyValuePairInStore(sessionStorage, key, value)) {
        overwritten = true;
    }
    if (!overwritten) {
        sessionStorage.setItem(key, value);
    }
};
/**
 * Converts the strings '', 'undefined' and 'null' to null
 * @returns {string, null}
 */
exports.getValidValue = function (value) {
    if (!value) {
        return null;
    }
    var invalidValues = ['', 'null', 'undefined'];
    if (invalidValues.some(function (v) { return v === value.trim(); })) {
        return null;
    }
    return value;
};
/**
 * Return param from localStorage
 * @returns {string, null}
 */
exports.getStringFromLocalStorage = function () {
    var params = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        params[_i] = arguments[_i];
    }
    return params
        .map(function (param) { return exports.getValidValue(window.localStorage.getItem(param)); })
        .find(function (v) { return v !== null; }) || null;
};
/**
 * Return param from sessionStorage
 * @returns {string, null}
 */
exports.getStringFromSessionStorage = function () {
    var params = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        params[_i] = arguments[_i];
    }
    return params
        .map(function (param) { return exports.getValidValue(window.sessionStorage.getItem(param)); })
        .find(function (v) { return v !== null; }) || null;
};
/**
 * Return string from query params
 * @returns {string, null}
 */
exports.getStringFromQuery = function (query) {
    var params = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        params[_i - 1] = arguments[_i];
    }
    return params
        .map(function (param) { return ((!query || !query[param])
        ? null
        : exports.getValidValue(query[param])); })
        .find(function (v) { return v !== null; }) || null;
};
/**
 * Return param from sources in order:
 * 1. query params
 * 2. sessionStorage
 * 3. localStorage
 *
 * @returns {string, null} string containing param or null
 */
exports.getParam = function (query, include) {
    var params = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        params[_i - 2] = arguments[_i];
    }
    var values = {
        localStorage: exports.getStringFromLocalStorage.apply(void 0, params),
        sessionStorage: exports.getStringFromSessionStorage.apply(void 0, params),
        query: exports.getStringFromQuery.apply(void 0, __spreadArrays([query], params)),
    };
    if (include.query && values.query) {
        return values.query;
    }
    if (include.sessionStorage && values.sessionStorage) {
        return values.sessionStorage;
    }
    if (include.localStorage && values.localStorage) {
        return values.localStorage;
    }
    return null;
};
/**
 * Return boolean from sources in order:
 * 1. query params
 * 2. sessionStorage
 * 3. localStorage
 *
 * @returns {boolean, null}
 */
exports.getBool = function (query, include) {
    var params = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        params[_i - 2] = arguments[_i];
    }
    var value = exports.getParam.apply(void 0, __spreadArrays([query, include], params));
    if (!value) {
        return null;
    }
    return value.toUpperCase() !== 'FALSE';
};
/**
 * Removes old and stores new key value pair, in either sessionStorage or localStorage
 * based on the optional `remember_me` argument
 */
exports.storeKeyValuePair = function (key, value, rememberMe) {
    if (rememberMe === true) {
        sessionStorage.removeItem(key);
        localStorage.setItem(key, value);
    }
    else if (rememberMe === false) {
        localStorage.removeItem(key);
        sessionStorage.setItem(key, value);
    }
    else {
        overrideKeyValuePair(key, value);
    }
};
//# sourceMappingURL=utils.js.map